import {filter, keyBy, get, createSelector, createStructuredSelector, config} from 'helpers';
import {date, dateString, type} from 'store/common';
import {index} from './list';

const isPredefined = question => !/_manual$/.test(question.type);

const byOrder = (a, b) => a.order - b.order;

const matchesType = createSelector(
  [ date, type ],
  ( date, type ) => {
    const manual = type + '_manual';
    if (type == 'reflections') {
      type += '_' + get({ Mon: 1, Tue: 3, Wed: 2, Thu: 1, Fri: 3, Sat: 4, Sun: 5 }, date.format('ddd'));
    }
    return question => question.type == manual || question.type == type;
  },
);

export const questions = createSelector(
  [ dateString, matchesType, state => state.questions ],
  ( dateString, matchesType, questions ) => {
    const makeItem = q => ({
      ...q,
      key: isPredefined(q) ? config.questions[q.type + '_' + q.key] : q.key,
      order: isPredefined(q) ? q.key : q.id,
      value: q.date == dateString ? q.value : '',
      predefined: isPredefined(q)
    });
    return filter(questions, matchesType).map(makeItem).sort(byOrder);
  }
);

const checkInIndex = createSelector(index, index => keyBy(index, record => {
  if (/\breflections\b/i.test(record.subject)) {
    return record.date + 'reflections';
  } else if (/\bmorning thoughts\b/i.test(record.subject)) {
    return record.date + 'morning_thoughts';
  } else if (/\bdaily check-in\b/i.test(record.subject)) {
    return record.date + 'midday';
  }
}));

export const matchedDiaryId = createSelector(
  [ date, type, checkInIndex ],
  ( date, type, checkInIndex ) => checkInIndex[date.unix()+type],
);

export const questionsBlacklist = state => state.settings.today.diaryQuestionsBlacklist;

export const checkIn = createStructuredSelector({ questions, matchedDiaryId });

